import React, { ComponentState, useEffect, useState } from "react"
import SkeletonTypography from "../../../../../components/SkeletonTypography";
import { Paper, TablePagination } from "@mui/material";
import { DocumentRequestObj, MetaData, QuestionnaireRequestObj, ResultDocumentData } from "../../../../../dataModel/documentModels";
import moment from "moment";
import { useDispatch } from "react-redux";
import { getDocumentUrl } from "../../../../../redux/actions";

export interface listProps {
    loadingState: boolean
    documentList: ResultDocumentData[]
    metaObj?: MetaData
    requestObj: QuestionnaireRequestObj
    handleChangePage(event: any, newpage: number): void
    handleChangeRowsPerPage(event: any): void
    tabSelecteionID: string
    tabId: number
}

export const QuestionnaireListComponent = (props: listProps) => {

    const dispatch = useDispatch()
    const {
        loadingState,
        documentList,
        metaObj,
        requestObj,
        tabSelecteionID,
        tabId,
        handleChangePage,
        handleChangeRowsPerPage
    } = props;




    return (
        <div className="tab-pane" id={tabSelecteionID} role="tabpanel">
            {(loadingState) ? <SkeletonTypography /> :
                <Paper>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Questionnaire</th>
                                <th>Date</th>
                                <th>Staff</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody style={{ padding: "auto 10px auto 10px" }}>
                            {
                                documentList?.map((item: any) => {
                                    return (
                                        <tr >
                                            <td>{item.questionnaire}</td>
                                            <td className="cursor-default ">
                                                {moment
                                                .utc(item.utcDateCreated)
                                                .local()
                                                .format("M/D/YYYY")}
                                            </td>                                       
                                            <td>{item.createdByStaff}</td>
                                            <td className="td_link" onClick={() => {
                                                if((tabId === 3)){
                                                    dispatch(getDocumentUrl({ queId: item.id, tabIdQue: tabId, isUpdateQue: 'updateQue', id: item.id, questionnaire: item.questionnaire, questionnaireId: item.questionnaireId, enumId: item.enumId }))
                                                }else{
                                                    dispatch(getDocumentUrl({  queId: item.id, tabIdQue: tabId, isUpdateQue: false, id: item.id, questionnaire: item.questionnaire, questionnaireId: item.questionnaireId, enumId: item.enumId }))
                                                }
                                               
                                            }}>View Questionnaire</td>

                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100, 500]}
                        component="div"
                        count={metaObj?.totalCount ?? 0}
                        rowsPerPage={requestObj.pageSize}
                        page={requestObj.pageNumber - 1}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            }
        </div>)
}